import { createFileRoute } from '@tanstack/react-router'
import { ResumeSharePage } from '@/features/resume-share/share-page'

export const Route = createFileRoute('/share/$token')({
  component: SharePageRoute,
})

function SharePageRoute() {
  const { token } = Route.useParams()
  return <ResumeSharePage token={token} />
}
